import {Location} from '@angular/common';
import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {BehaviorSubject, Observable, ReplaySubject, Subject, Subscription} from 'rxjs';
import {delay, filter, take, takeUntil} from 'rxjs/operators';
// tslint:disable-next-line: max-line-length

import {TranslateService} from '@ngx-translate/core';
import {ParticipantListComponent} from '../../../shared_components/participant/participant-list/participant-list.component';
import {UploadFileComponent} from '../../../shared_components/upload-file/upload-file.component';
import {
    AssignmentModel, AuditTrailModel, AuditTrailOnServerCreated, AuditTrailParticipantModel, AuditTrailParticipantsPageRequested,
    OneAssignmentRequest,
    selectAssignmentById,
    selectAuditTrailParticipants,
    selectAuditTrailsActionLoading, selectLastCreatedAuditTrailId
} from '../../../../../core/assignment';
import {AllClientsRequested, Client, selectAllClients} from '../../../../../core/admin';
import {AllInteractionTypesRequested, InteractionType, selectAllInteractionTypes} from '../../../../../core/linked-tables';
import {User, currentUser} from 'src/app/core/mad-auth/mad-auth.store';
import {LayoutConfigService, SubheaderService} from '../../../../../core/_base/layout';
import {LayoutUtilsService, QueryParamsModel, TypesUtilsService} from '../../../../../core/_base/crud';
import {AppState} from '../../../../../core/reducers';
import {AuditTrailsService} from '../../../../../core/assignment/_services';
import {selectToesInStore, ToesPageRequested} from 'src/app/core/toe';
import {AssetClassesPageRequested, selectAssetClassesInStore} from 'src/app/core/asset_class';
import { AuditTrailOnServerUpdated } from 'src/app/core/assignment/_actions/audit-trail.actions';

const PARTICIPANTS_SIDE: string[] = ['None', 'Our Side', 'Client Side', 'External'];
const IMPACT_ON_VALUATION: string[] = ['None', 'Low', 'Medium', 'High'];

@Component({
    selector: 'kt-audit-edit',
    templateUrl: './audit-edit.component.html',
    styleUrls: ['./audit-edit.component.scss'],
})
export class AuditEditComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(ParticipantListComponent, {static: true}) participantListComponent;
    @ViewChild(UploadFileComponent, {static: true})
    public uploadFileComponent: UploadFileComponent;
    // searchable selection
    @ViewChild('singleSelectToe', {static: true}) singleSelectToe: MatSelect;
    @ViewChild('singleSelectInteractionType', {static: true}) singleSelectInteractionType: MatSelect;
    @ViewChild('singleSelectValuation', {static: true}) singleSelectValuation: MatSelect;
    displayedColumns = ['type', 'title', 'descr', 'actions'];

    auditTrail: AuditTrailModel;
    oldAuditTrail: AuditTrailModel;
    participantsSubject = new BehaviorSubject<AuditTrailParticipantModel[]>([]);
    clients: Client[] = [];
    participantsSide: string[] = [];
    impactOnValuation: string[] = [];
    toes: any[] = [];
    interactionTypes: InteractionType[] = [];
    assetClasses: any[] = [];
    auditTrailForm: UntypedFormGroup;
    hasFormErrors = false;
    dataLoaded = false;
    readOnly = false;
    filteredOptions: Observable<any[]>;
    // filteredOptions: Observable<ToeModel[]>;h
    dataSource = new MatTableDataSource();

    loading$: Observable<boolean>;

    private componentSubscriptions: Subscription;
    private subscriptions: Subscription[] = [];
    assignmentId: number;
    assignment: AssignmentModel;
    currentUser: User;
    saveState: boolean;
    agencyName: BehaviorSubject<string> = new BehaviorSubject(null);
    agencyId$: BehaviorSubject<number> = new BehaviorSubject(0);
    clientName: BehaviorSubject<string> = new BehaviorSubject(null);
    clientId$: BehaviorSubject<number> = new BehaviorSubject(0);
    toeSelected: BehaviorSubject<boolean> = new BehaviorSubject(false);
    toeId$: BehaviorSubject<number> = new BehaviorSubject(0);
    atLeastOneParticipant$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    /** control for the MatSelect filter keyword */
    public filterCtrl: UntypedFormControl = new UntypedFormControl();
    public filterCtrlInteractionType: UntypedFormControl = new UntypedFormControl();
    public filterCtrlValuation: UntypedFormControl = new UntypedFormControl();

    protected _onDestroy = new Subject<void>();
    /** list of models filtered by search keyword */
    public filteredSelectionModels: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    public filteredInteractionTypes: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    public filteredValuations: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    fileType = '';
    isEdit = false;

    /**
     * Component constructor
     * @param activatedRoute
     * @param router: Router
     * @param fb: FormBuilder
     * @param subheaderService: SubheaderService
     * @param layoutUtilsService
     * @param store: Store<AppState>
     * @param typesUtilsService: TypesUtilsService
     * @param layoutConfigService: LayoutConfigService
     * @param auditTrailsService: AuditTrailsService
     * @param location: Location
     * @param translate: TranslateService
     */
    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private fb: UntypedFormBuilder,
                private subheaderService: SubheaderService,
                public typesUtilsService: TypesUtilsService,
                private layoutUtilsService: LayoutUtilsService,
                private store: Store<AppState>,
                private layoutConfigService: LayoutConfigService,
                public auditTrailsService: AuditTrailsService,
                private location: Location,
                private translate: TranslateService) {
        this.saveState = false;
        this.fileType = '';
    }

    ngOnInit() {

        this.subheaderService.setTitle('New Interaction');
        this.subheaderService.setBreadcrumbs([
            {title: 'Main menu', page: `../default/assignment`},
            {title: 'Assignments', page: `../default/assignment/assignments`},
            {title: 'To do', page: `../default/assignment/assignments/todo`},
            {title: 'Interactions', page: `../default/assignment/assignments/todo/audit-trails`},
            {title: 'New', page: `../default/assignment/assignments/todo/audit-trails/add`},
        ]);

        this.loading$ = this.store.pipe(select(selectAuditTrailsActionLoading));

        this.assignmentId = Number(this.activatedRoute.snapshot.paramMap.get('id'));
        this.store.dispatch(new OneAssignmentRequest({id: this.assignmentId}));
        this.participantsSide = PARTICIPANTS_SIDE;
        this.impactOnValuation = IMPACT_ON_VALUATION;

        if (this.router.url.indexOf('trash-detail') > -1) {
            this.activatedRoute.data.subscribe(data => {
                const res = data.data;
                this.oldAuditTrail = res.data;
                this.auditTrail = Object.assign({}, this.oldAuditTrail);
                this.dataLoaded = true;
                this.readOnly = true;
                this.createForm();

                // participants
                this.store.dispatch(new AuditTrailParticipantsPageRequested({auditTrailId: this.auditTrail.id}));
                this.store.pipe(
                    takeUntil(this._onDestroy),
                    select(selectAuditTrailParticipants)
                ).subscribe((res) => {
                    if (!res) {
                        return;
                    }
                    this.participantsSubject.next(res);
                });

                if (this.auditTrail.terms_of_engagement_id != null) {
                    this.toeSelected.next(true);
                    this.clientName.next(this.auditTrail.client_name);
                    this.clientId$.next(this.auditTrail.client_id);
                } else {
                    this.toeSelected.next(false);
                }
                this.toeId$.next(this.auditTrail.terms_of_engagement_id);

                // this.splitFileNames();
            });
        } else if (this.router.url.indexOf('show') > -1) {
            this.activatedRoute.data.subscribe(data => {
                const res = data.data;
                this.oldAuditTrail = res.data;
                this.auditTrail = Object.assign({}, this.oldAuditTrail);
                this.dataLoaded = true;
                this.readOnly = true;
                this.createForm();

                // participants
                this.store.dispatch(new AuditTrailParticipantsPageRequested({auditTrailId: this.auditTrail.id}));
                this.store.pipe(
                    takeUntil(this._onDestroy),
                    select(selectAuditTrailParticipants)
                ).subscribe((res) => {
                    if (!res) {
                        return;
                    }
                    this.participantsSubject.next(res);
                });
                if (this.auditTrail.terms_of_engagement_id != null) {
                    this.toeSelected.next(true);
                    this.clientName.next(this.auditTrail.client_name);
                    this.clientId$.next(this.auditTrail.client_id);
                } else {
                    this.toeSelected.next(false);
                }
                this.toeId$.next(this.auditTrail.terms_of_engagement_id);
                // this.splitFileNames();
            });
        } else if (this.router.url.indexOf('edit') > -1) {
            this.activatedRoute.data.subscribe(data => {
                const res = data.data;
                this.oldAuditTrail = res.data;
                this.auditTrail = Object.assign({}, this.oldAuditTrail);
                this.dataLoaded = true;
                this.readOnly = false;
                this.isEdit = true;
                this.createForm(true);

                // participants
                this.store.dispatch(new AuditTrailParticipantsPageRequested({auditTrailId: this.auditTrail.id}));
                this.store.pipe(
                    takeUntil(this._onDestroy),
                    select(selectAuditTrailParticipants)
                ).subscribe((res) => {
                    if (!res) {
                        return;
                    }
                    this.participantsSubject.next(res);
                });
                if (this.auditTrail.terms_of_engagement_id != null) {
                    this.toeSelected.next(true);
                    this.clientName.next(this.auditTrail.client_name);
                    this.clientId$.next(this.auditTrail.client_id);
                } else {
                    this.toeSelected.next(false);
                }
                this.toeId$.next(this.auditTrail.terms_of_engagement_id);

                this.populateAssetClasses(this.auditTrail.terms_of_engagement_id)
            })
        } else {
            this.oldAuditTrail = new AuditTrailModel();
            this.oldAuditTrail.clear();
            this.oldAuditTrail.interaction_date = this.typesUtilsService.getDateStringFromDate(new Date());
            this.auditTrail = Object.assign({}, this.oldAuditTrail);
            this.dataLoaded = true;
            this.readOnly = false;
            this.createForm();
        }
        this.store.pipe(select(selectAssignmentById(this.assignmentId))).subscribe(res => {
            if (res) {
                this.assignment = res;
                this.agencyName.next(this.assignment.agency_name);
                this.agencyId$.next(this.assignment.agency_id);
            }
        });

        this.filterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterSelectionModels();
            });

        this.filterCtrlInteractionType.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterInteractionTypes();
            });

        this.filterCtrlValuation.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterValuations();
            });

        if (this.readOnly && this.auditTrail.terms_of_engagement_id != 0) {
            this.populateAssetClasses(this.auditTrail.terms_of_engagement_id);
        }
    }

    ngAfterViewInit() {
        this.setInitialValueToE();
        this.setInitialValueInteractionType();
        this.setInitialValueValuation();
    }

    fetchSelects() {
        const userSubscription = this.store.pipe(
            select(currentUser))
            .subscribe(res => {
                if (res) {
                    this.currentUser = res;
                }
            });
        this.subscriptions.push(userSubscription);

        this.store.dispatch(new AllClientsRequested());

        const clientSubscription = this.store.pipe(
            select(selectAllClients))
            .subscribe(res => {
                this.clients = [];
                if (res) {
                    this.clients = res;
                    this.auditTrailForm.controls.client_id.patchValue(this.auditTrail.client_id);
                }
            });

        this.subscriptions.push(clientSubscription);

        this.store.dispatch(new AllInteractionTypesRequested());

        const interactionTypesSubscription = this.store.pipe(
            select(selectAllInteractionTypes))
            .subscribe(res => {
                if (res) {
                    this.interactionTypes = res;
                    this.filteredInteractionTypes.next(this.interactionTypes.slice());
                }
            });

        this.subscriptions.push(interactionTypesSubscription);

        const queryParams = new QueryParamsModel(
            {name: ''},
            'asc',
            'status',
            1,
            25
        );

        this.store.dispatch(new ToesPageRequested({page: queryParams, assignmentId: this.assignmentId}));

        const toesSubscription = this.store.pipe(
            select(selectToesInStore))
            .subscribe(res => {
                if (res) {
                    this.toes = [{id: 0, name: 'General'}].concat(res.items);
                    this.filteredSelectionModels.next(this.toes.slice());
                }
            });

        this.subscriptions.push(toesSubscription);

        this.filteredValuations.next(this.impactOnValuation.slice());
    }

    ngOnDestroy(): void {
        if (this.componentSubscriptions) {
            this.componentSubscriptions.unsubscribe();
        }
        this.subscriptions.forEach(el => el.unsubscribe());
    }

    /**
     * Returns page title
     */
    getComponentTitle(): string {
        if (this.auditTrail && this.auditTrail.id && this.readOnly) {
            // return `Interaction Detail #${this.auditTrail.id} for Assignment '${this.auditTrail.assignment_name}' (View Only)`;
            return this.translate.instant('AUDIT_TRAIL.FORM.TITLE.DETAIL_VIEW', {
                id: this.auditTrail.ref_num,
                assignment_name: this.auditTrail.assignment_name
            });
        } else if ((this.auditTrail && this.auditTrail.id && !this.readOnly)) {
            return this.translate.instant('AUDIT_TRAIL.FORM.TITLE.DETAIL', {
                id: this.auditTrail.ref_num,
                assignment_name: this.auditTrail.assignment_name
            });
        }
        // return `New Interaction for Assignment '${this.assignment ? this.assignment.name : ''}'`;
        return this.translate.instant('AUDIT_TRAIL.FORM.TITLE.NEW', {
            assignment_name: (this.assignment ? this.assignment.name : '')
        });
    }

    createForm(isEdit: boolean = false) {
        this.auditTrailForm = this.fb.group({
            interaction_date: [{
                value: this.typesUtilsService.getDateFromString(this.auditTrail.interaction_date),
                disabled: this.readOnly || isEdit
            }, Validators.required],
            client_id: [{value: this.auditTrail.client_id, disabled: true}],
            terms_of_engagement_id: [{
                value: this.auditTrail.terms_of_engagement_id,
                disabled: this.readOnly || isEdit
            }, Validators.required],
            asset_class_id: [{
                value: this.auditTrail.asset_class_id,
                disabled: this.readOnly || isEdit
            }],
            interaction_type_id: [{
                value: this.auditTrail.interaction_type_id,
                disabled: this.readOnly || isEdit
            }, Validators.required],
            interaction_description: [{value: this.auditTrail.interaction_description, disabled: this.readOnly}, Validators.required],
            location: [{value: this.auditTrail.location, disabled: this.readOnly}],
            impact_on_valuation: [{
                value: this.auditTrail.impact_on_valuation ? this.auditTrail.impact_on_valuation : '',
                disabled: this.readOnly
            }, Validators.required],
            mitigation_strategy: [{
                value: this.auditTrail.mitigation_strategy ? this.auditTrail.mitigation_strategy : '',
                disabled: this.readOnly
            }, Validators.required],
            mitigation_strategy1: [{
                value: this.auditTrail.mitigation_strategy1 ? this.auditTrail.mitigation_strategy1 : '',
                disabled: this.readOnly
            }, Validators.required],
        });

        this.auditTrailForm.controls.terms_of_engagement_id.valueChanges.subscribe(toeId => {
            if (toeId != 0) {
                this.populateAssetClasses(toeId);
                this.auditTrailForm.controls.asset_class_id.setValidators([Validators.required]);
            } else {
                this.auditTrailForm.controls.asset_class_id.clearValidators();
            }
            this.auditTrailForm.controls.asset_class_id.updateValueAndValidity();
        });

        this.fetchSelects();
    }

    /**
     * Check control is invalid
     * @param controlName: string
     */
    isControlInvalid(controlName: string): boolean {
        const control = this.auditTrailForm.controls[controlName];
        const result = control.invalid && control.touched;
        return result;
    }

    /**
     * Alert close event
     */
    onAlertClose($event) {
        this.hasFormErrors = false;
    }

    isFormValid() {
        const controls = this.auditTrailForm.controls;
        const _date = controls.interaction_date.value;

        const interactionDescription = controls.interaction_description.value;
        const interactionTypeId = controls.interaction_type_id.value;
        const impactOnValuation = controls.impact_on_valuation.value;
        const mitigationStrategy = controls.mitigation_strategy.value;

        return _date &&
            interactionDescription && interactionDescription.length > 0 &&
            impactOnValuation &&
            mitigationStrategy && mitigationStrategy.length > 0 &&
            interactionTypeId;
    }

    /**
     * Returns prepared assignment
     */
    prepareAuditTrail(): AuditTrailModel {
        const controls = this.auditTrailForm.controls;
        const _auditTrail = new AuditTrailModel();
        _auditTrail.clear();
        _auditTrail.id = this.oldAuditTrail.id;
        _auditTrail.assignment_id = this.assignmentId;
        const _date = new Date(controls.interaction_date.value);

        if (_date) {
            _auditTrail.interaction_date = this.typesUtilsService.getDateStringFromDate(_date);
        } else {
            _auditTrail.interaction_date = '';
        }
        _auditTrail.client_id = controls.client_id.value;
        _auditTrail.terms_of_engagement_id = controls.terms_of_engagement_id.value;
        _auditTrail.asset_class_id = controls.asset_class_id.value;
        _auditTrail.interaction_description = controls.interaction_description.value;
        _auditTrail.interaction_type_id = controls.interaction_type_id.value;
        _auditTrail.location = controls.location.value;
        _auditTrail.user_id = this.currentUser.id;
        _auditTrail.impact_on_valuation = controls.impact_on_valuation.value;
        _auditTrail.mitigation_strategy = controls.mitigation_strategy.value;
        _auditTrail.mitigation_strategy1 = controls.mitigation_strategy1.value;
        this.uploadFileComponent.res$.pipe(take(1)).subscribe(value => {
            if (value) {
                _auditTrail.picture = value.success;
            }
        });
        return _auditTrail;
    }

    /**
     * On Submit
     */
    onSubmit() {
        const editedAssignment = this.prepareAuditTrail();
        if (this.isEdit) {
            this.updateAuditTrail(editedAssignment);
            return;
        }
        this.createAuditTrail(editedAssignment);
    }

    updateAuditTrail(_auditTrail: AuditTrailModel) {
        const _participants = [];

        for (const item of this.participantListComponent ? this.participantListComponent.participants : []) {
            const _newItem = Object.assign({}, item) as AuditTrailParticipantModel;
            _newItem.linked_id = this.auditTrail.id;
            _participants.push(_newItem);
        }

        this.store.dispatch(new AuditTrailOnServerUpdated({
            item: _auditTrail,
            assignmentId: this.assignmentId,
            participants: _participants,
            fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : []
        }));
        this.location.back()
    }

    /**
     * Create assignment
     *
     * @param _auditTrail: AuditTrailModel
     */
    createAuditTrail(_auditTrail: AuditTrailModel) {


        const _participants = [];

        for (const item of this.participantListComponent ? this.participantListComponent.participants : []) {
            const _newItem = Object.assign({}, item) as AuditTrailParticipantModel;
            _newItem.linked_id = this.auditTrail.id;
            _participants.push(_newItem);
        }

        this.store.dispatch(new AuditTrailOnServerCreated({
            item: _auditTrail,
            assignmentId: this.assignmentId,
            participants: _participants,
            fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : []
        }));

        this.oldAuditTrail = _auditTrail;
        this.componentSubscriptions = this.store.pipe(
            select(selectLastCreatedAuditTrailId),
            filter(value => value !== undefined)
        ).subscribe(res => {
            if (!res) {
                return;
            }
            this.saveState = true;
            // this.router.navigate(['../'], {relativeTo: this.activatedRoute});
            const url = `${this.layoutConfigService.getCurrentMainRoute()}/assignment/assignments/${this.assignmentId}/audit-trails`;
            this.router.navigate([url], {relativeTo: this.activatedRoute});
        });
    }

    auditTrailSaveNotification() {
        this.hasFormErrors = false;
        const controls = this.auditTrailForm.controls;
        /** check form */
        if (this.auditTrailForm.invalid) {
            Object.keys(controls).forEach(controlName =>
                controls[controlName].markAsTouched()
            );

            this.hasFormErrors = true;
            return;
        }

        const _title = this.translate.instant('AUDIT_TRAIL.FORM.DIALOG.SAVE.TITLE');
        const _description = this.translate.instant('AUDIT_TRAIL.FORM.DIALOG.SAVE.DESCRIPTION');
        const _waitDesciption = this.translate.instant('AUDIT_TRAIL.FORM.DIALOG.SAVE.WAIT_DESCRIPTION');

        const dialogRef = this.layoutUtilsService.saveElement(_title, _description, _waitDesciption);
        dialogRef.afterClosed().subscribe(res => {
            if (!res) {
                return;
            }
            this.onSubmit();
        });
    }

    changeClient($event) {
        if ($event.value != 0) {
            this.toeSelected.next(true);
            const toe = this.toes.find((item) => {
                return item.id === Number($event.value);
            });
            if (toe) {
                this.auditTrailForm.controls.client_id.patchValue(toe.client_id);
                this.clientName.next(toe.client_name);
                this.clientId$.next(toe.client_id);
                this.toeId$.next(toe.id);
            } else {
                this.auditTrailForm.controls.client_id.patchValue(null);
                this.toeSelected.next(false);
                this.toeId$.next(null);
            }
        } else {
            this.toeSelected.next(false);
            this.auditTrailForm.controls.client_id.patchValue(null);
            this.toeId$.next(null)
        }
        this.participantsSubject.next(this.participantsSubject.value.filter(p => p.ref_id == null))
    }

    canDeactivate() {
        if (this.discard()) {
            if (window.confirm(this.translate.instant('GENERAL.MESSAGE.LOST_CHANGES'))) {
                return true;
            } else {
                // ---------work around angular bug--------- reference: https://github.com/angular/angular/issues/13586
                const currentUrlTree = this.router.createUrlTree([], this.activatedRoute.snapshot);
                const currentUrl = currentUrlTree.toString();
                this.location.go(currentUrl);
                // ---------work around end-----------------
                return false;
            }
        }
        return true;
    }

    discard() {
        const currentItem = this.prepareAuditTrail();
        return !this.saveState && (currentItem.interaction_date !== this.oldAuditTrail.interaction_date ||
            currentItem.terms_of_engagement_id !== this.oldAuditTrail.terms_of_engagement_id ||
            currentItem.interaction_type_id !== this.oldAuditTrail.interaction_type_id ||
            currentItem.impact_on_valuation !== this.oldAuditTrail.impact_on_valuation ||
            currentItem.location !== this.oldAuditTrail.location ||
            currentItem.interaction_description !== this.oldAuditTrail.interaction_description ||
            currentItem.mitigation_strategy !== this.oldAuditTrail.mitigation_strategy);
    }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHander($event) {
        if (this.discard()) {
            $event.preventDefault();
            $event.returnValue = 'test';
        }
    }

    /**
     * Sets the initial value after the filteredSelectionModels are loaded initially
     */
    protected setInitialValueToE() {
        this.filteredSelectionModels
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.singleSelectToe.compareWith = (a: string, b: string) => {
                    return a === b;
                };
            });
    }

    protected setInitialValueInteractionType() {
        this.filteredInteractionTypes
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.singleSelectInteractionType.compareWith = (a: string, b: string) => {
                    return a === b;
                };
            });
    }

    protected setInitialValueValuation() {
        this.filteredValuations
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.singleSelectValuation.compareWith = (a: string, b: string) => {
                    return a === b;
                };
            });
    }

    protected filterSelectionModels() {
        if (!this.toes) {
            return;
        }
        // get the search keyword
        let search = this.filterCtrl.value;
        if (!search || search === '') {
            this.filteredSelectionModels.next(this.toes.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the models
        this.filteredSelectionModels.next(
            this.toes.filter(client => client.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterInteractionTypes() {
        if (!this.interactionTypes) {
            return;
        }
        // get the search keyword
        let search = this.filterCtrlInteractionType.value;
        if (!search || search === '') {
            this.filteredInteractionTypes.next(this.interactionTypes.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the models
        this.filteredInteractionTypes.next(
            this.interactionTypes.filter(interactionType => interactionType.name.toLowerCase().indexOf(search) > -1)
        );
    }

    protected filterValuations() {
        if (!this.impactOnValuation) {
            return;
        }
        // get the search keyword
        let search = this.filterCtrlValuation.value;
        if (!search || search === '') {
            this.filteredValuations.next(this.impactOnValuation.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the models
        this.filteredValuations.next(
            this.impactOnValuation.filter(valuation => valuation.toLowerCase().indexOf(search) > -1)
        );
    }

    populateAssetClasses(_toeId) {
        const queryParams = new QueryParamsModel(
            {},
            'asc',
            'status',
            1,
            25
        );

        this.store.dispatch(new AssetClassesPageRequested({page: queryParams, toeId: _toeId}));

        const assetClassesSubscription = this.store.pipe(
            select(selectAssetClassesInStore))
            .subscribe(res => {
                if (res) {
                    this.assetClasses = [{id: 0, name: 'General'}].concat(res.items);
                    if (this.auditTrail.asset_class_id) {
                        this.auditTrailForm.controls.asset_class_id.setValue(this.auditTrail.asset_class_id);
                    }
                }
            });

        this.subscriptions.push(assetClassesSubscription);
    }

    clearDate(_control) {
        _control.setValue(null);
        _control.updateValueAndValidity();
    }

    goBack() {
        if (this.readOnly) {
            this.location.back()
            return
        }
        if (this.isEdit) {
            this.location.back()
            return
        }
        this.router.navigate(['../'], {relativeTo: this.activatedRoute});
    }
}
